export default "__VITE_ASSET__YxzWmqOj__"